import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { useClientApiKeys } from "@hooks/useClientSettings";
import { appVersion, envMode, apiUrlOriginacaoDefault } from "@settings";
import { useEffect, useRef, useMemo } from "react";

export const DataDogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { dataDog } = useClientApiKeys();

  const hasInitialized = useRef(false);
  const plugin = useMemo(() => reactPlugin({ router: true }), []);

  useEffect(() => {
    const { applicationId, clientToken, serviceName } = dataDog ?? {};

    if (
      hasInitialized.current ||
      !applicationId ||
      !clientToken ||
      !serviceName
    ) {
      return;
    }

    hasInitialized.current = true;

    // Configuração diferenciada para cliente Happy conforme orientação do time Datadog
    const isHappyClient = serviceName === "happy";

    datadogRum.init({
      applicationId,
      clientToken,
      site: "datadoghq.com",
      service: serviceName,
      env: envMode,
      version: appVersion,
      sessionSampleRate: isHappyClient ? 15 : 5, // Happy: 15%, outros: 5%
      sessionReplaySampleRate: isHappyClient ? 5 : 0, // Happy: 5%, outros: 0%
      defaultPrivacyLevel: "mask-user-input",
      plugins: [plugin],
      allowedTracingUrls: [apiUrlOriginacaoDefault],
    });
  }, [dataDog, plugin]);

  return <>{children}</>;
};
